var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeadboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.6,
    height: 44.466,
    viewBox: "0 0 45.6 44.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_339",
    "data-name": "Rettangolo 339",
    width: 23.063,
    height: 24.788,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Leadboard",
    transform: "translate(-5528.805 -262.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ButtonIcon_-_Cup",
    "data-name": "ButtonIcon - Cup",
    transform: "translate(5528.805 262.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ButtonIcon_shape",
    "data-name": "ButtonIcon shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_983",
    "data-name": "Tracciato 983",
    d: "M12.756,0,.443,11.22,0,27.738,6.216,40.819l15.8,3.647L37.394,37.62,45.6,22.25,38.865,3.439,20.689.1Z",
    transform: "translate(0 0)",
    fill: "#c78b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_713",
    "data-name": "Raggruppa 713",
    transform: "translate(9.436 9.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_712",
    "data-name": "Raggruppa 712",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1146",
    "data-name": "Tracciato 1146",
    d: "M67.776,7.591A11.292,11.292,0,0,1,70.281,5.68l2.262,3.654-4.881,3.584.113-1.392L70.16,9.16,69.823,7.8Z",
    transform: "translate(-49.481 -4.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1147",
    "data-name": "Tracciato 1147",
    d: "M4.753,7.839a11.3,11.3,0,0,0-2.521-1.89L0,9.621l4.91,3.55-.124-1.4-2.4-2.346.326-1.36Z",
    transform: "translate(0 -4.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1148",
    "data-name": "Tracciato 1148",
    d: "M36.4,51.219l-1.009,2.923L36.4,58.021h1.315l1.295-3.407-.81-3.151Z",
    transform: "translate(-25.881 -37.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1149",
    "data-name": "Tracciato 1149",
    d: "M16.673,81.272l4.64-1.546h3.109l5.011,1.546.186,1.818H16.139Z",
    transform: "translate(-11.802 -58.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1150",
    "data-name": "Tracciato 1150",
    d: "M17.4,0l.27,2.844,1.034,5.329,2.9,3.41,1.6,1.044,2.184.278,4.219-3.341L31.226,0Zm6.745,9.051-.037.087a.72.72,0,0,1-1.332-.012.721.721,0,0,0-.367-.385l-.364-.168a.72.72,0,0,1,.016-1.316l.245-.106a.721.721,0,0,0,.376-.376l.078-.182a.721.721,0,0,1,1.325,0l.065.153a.72.72,0,0,0,.374.378l.252.11a.72.72,0,0,1,0,1.319l-.259.114a.721.721,0,0,0-.373.379M27.569,6.22l-.025.059a.49.49,0,0,1-.906-.008.491.491,0,0,0-.25-.262l-.247-.114a.49.49,0,0,1,.011-.9l.167-.072a.49.49,0,0,0,.256-.256l.053-.124a.49.49,0,0,1,.9,0l.044.1a.491.491,0,0,0,.254.257L28,4.987a.49.49,0,0,1,0,.9l-.176.078a.491.491,0,0,0-.254.258M22.44,4.688l-.016.038a.317.317,0,0,1-.585-.005.317.317,0,0,0-.161-.169l-.16-.074a.316.316,0,0,1,.007-.578l.108-.046a.316.316,0,0,0,.165-.165l.035-.08a.317.317,0,0,1,.582,0l.028.067a.317.317,0,0,0,.164.166l.11.048a.317.317,0,0,1,0,.58l-.114.05a.316.316,0,0,0-.164.166",
    transform: "translate(-12.726 0)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeadboard);
export default __webpack_public_path__ + "static/media/Icon_Leadboard.8999c9c72c4cddcadda1ae49bcaabdbc.svg";
export { ForwardRef as ReactComponent };